<div class="container">
  <div class="header-container">
    <h1>Dictionaries</h1>
    <div class="table-header">
      <button mat-icon-button color="primary" matTooltipPosition=right matTooltip="Refresh" (click)="refreshData()">
        @if (!isRefreshing) {
          <mat-icon>refresh</mat-icon>
        }
        @if (isRefreshing) {
          <mat-spinner matTooltipPosition=right matTooltip="Working..." [diameter]="24"></mat-spinner>
        }
      </button>
    </div>
  </div>
  @if (!termWebAccessible) {
    <div class="termweb-warning">
      <mat-icon>cloud_off</mat-icon>
      <span>TermWeb is not accessible. Dictionary status may be outdated. Synchronization is disabled.</span>
    </div>
  }
  <table mat-table [dataSource]="dictStats" class="mat-elevation-z8">

    <ng-container matColumnDef="order">
      <th mat-header-cell class="cell-order" *matHeaderCellDef></th>
      <td mat-cell class="cell-order" *matCellDef="let stat; let i = index">
        <div class="order-buttons">
          <mat-icon class="order-icon"
            [class.disabled]="i === 0"
            (click)="i !== 0 && moveUp(i)"
            matTooltip="Move up">arrow_upward
          </mat-icon>
          <mat-icon class="order-icon"
            [class.disabled]="i === dictStats.length - 1"
            (click)="i !== dictStats.length - 1 && moveDown(i)"
            matTooltip="Move down">arrow_downward
          </mat-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell class="cell-numeric" *matHeaderCellDef>ID</th>
      <td mat-cell class="cell-numeric" *matCellDef="let stat"> {{ stat.id }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Name</th>
      <td mat-cell *matCellDef="let stat"
        [class.clickable]="!isInProgess(stat)"
        (click)="!isInProgess(stat) && openDictionaryDetails(stat)">
        <span matTooltipPosition="right" [matTooltip]="getNameTooltip(stat)"> {{ stat.name }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="languages">
      <th mat-header-cell *matHeaderCellDef> Languages</th>
      <td mat-cell *matCellDef="let stat"> {{ stat.languages }}</td>
    </ng-container>

    <ng-container matColumnDef="twConceptCount">
      <th mat-header-cell class="cell-numeric" *matHeaderCellDef> TermWeb Concepts</th>
      <td mat-cell class="cell-numeric" *matCellDef="let stat"> {{ stat.termWebConceptCount }}</td>
    </ng-container>

    <ng-container matColumnDef="pubConceptCount">
      <th mat-header-cell class="cell-numeric" *matHeaderCellDef> Published Concepts</th>
      <td mat-cell class="cell-numeric" *matCellDef="let stat"> {{ getConceptCount(stat) }}</td>
    </ng-container>

    <ng-container matColumnDef="syncStatus">
      <th mat-header-cell *matHeaderCellDef> Status</th>
      <td mat-cell *matCellDef="let stat">
        <pub-sync-status-indicator
          [status]="stat.deleted && termWebAccessible ? 'DELETED' : (!termWebAccessible && stat.deleted ? 'UNAVAILABLE' : stat.syncStats.status)"
        [message]="stat.syncStats.statusMessage"></pub-sync-status-indicator>
      </td>
    </ng-container>

    <ng-container matColumnDef="syncDate">
      <th mat-header-cell *matHeaderCellDef> Last sync</th>
      <td mat-cell *matCellDef="let stat"> {{ stat.syncStats.lastSyncDate | date: 'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="syncTime">
      <th mat-header-cell class="cell-numeric" *matHeaderCellDef> Sync time</th>
      <td mat-cell class="cell-numeric" *matCellDef="let stat"> {{ timeStr(stat.syncStats.lastSyncTimeMs) }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions</th>
      <td mat-cell *matCellDef="let stat">
        <button mat-icon-button
          [ngClass]="{'syncing': isInProgess(stat)}"
                [matTooltip]="!termWebAccessible ? 'TermWeb is not accessible' : (stat.syncStats.status === 'DELETING' ? 'Deleting index...' : (isInProgess(stat) ? 'Syncing...' : (isNotSynced(stat) || isFailed(stat) ? 'Start indexing' : 'Check for updates')))"
                [disabled]="!termWebAccessible || stat.deleted || isInProgess(stat)"
          (click)="fetchUpdates(stat)"
          [color]="(isNotSynced(stat) || isFailed(stat)) ? 'warn' : 'primary'">
          <mat-icon>sync</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns;"
      [ngClass]="{'row-disabled': !row.visible || !isComplete(row), 'row-highlight': i === highlightedIndex}">
    </tr>
  </table>
</div>
